import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatCard, MatCardActions, MatCardContent, MatCardHeader } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { Account } from 'src/app/models/account.model';
import { SharedModule } from '../../shared/shared.module';
import { AccountType } from 'src/app/enums/account-type.enum';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-account-summary-dialog',
  standalone: true,
  imports: [SharedModule, MatCard, CommonModule, MatCardHeader, MatCardContent, MatCardActions, MatButtonModule, MatButton],
  templateUrl: './account-summary-dialog.component.html', 
  styleUrl: './account-summary-dialog.component.scss'
})
export class AccountSummaryDialogComponent implements OnInit {

  account: any;
  accounts$?: Observable<Account[]>;
  error: boolean = false;

  cloudName:string = '';
  cloudService:string = '';
  yammerUrl: string = environment.yammerURl;


  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<AccountSummaryDialogComponent>) {
    this.account = {};
    if (data.account_name) {
      this.account = {
        accountName: data.account_name,
        accountStatus: data.account_status,
        asms : data.asms,
        environment : data.environment,
        type : data.type,
      };
    } else if (data.error) {
      this.error = true;
    }

  }

  ngOnInit(): void {
    this.accounts$ = of([this.account]);
    this.setText(this.account.type);
  }

  close(){
    this.dialogRef.close();
  }

  setText(typeId: AccountType) : void {
    const cloudDetails = {
      [AccountType.AWS]: { cloudName: "AWS", cloudService: "account" },
      [AccountType.Azure]: { cloudName: "Azure", cloudService: "subscription" },
      default: { cloudName: "cloud", cloudService: "account" }
    };

    const details = cloudDetails[typeId];
    this.cloudName = details.cloudName;
    this.cloudService = details.cloudService;
  }

  capitalize(s : string) : string{
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
}
